exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{box-sizing:border-box;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}#root,body,html{height:100%;font-family:proxima-nova,sans-serif}body{margin:0;padding:0;font-family:sans-serif}p{line-height:1.33}a{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/index.css
// module id = 175
// module chunks = 0